import { columnSettings, tableWidth } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const {
    mykey,
    no,
    data_service,
    tanggal_transaksi,
    speedo_akhir,
    keterangan,
  } = props;

  return (
    <tr
      key={mykey}
      // className="row-start-start w-full text-sm text-slate-700 !items-stretch"
      className={`row-start-start ${tableWidth} text-sm text-slate-700 !items-stretch`}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
      >
        {no}
      </td>

      <td
        className={`${settings["data_service"].layout} ${settings["data_service"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {data_service.nama}
      </td>
      <td
        className={`${settings["tanggal_transaksi"].layout} ${settings["tanggal_transaksi"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {tanggal_transaksi}
      </td>
      <td
        className={`${settings["speedo_akhir"].layout} ${settings["speedo_akhir"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {speedo_akhir.toLocaleString("id-ID")}
      </td>
      <td
        className={`${settings["keterangan"].layout} ${settings["keterangan"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {keterangan ?? "-"}
      </td>
    </tr>
  );
};

export default ReportTemplateDetail;
